import React from "react";
import {
  Stack,
  Typography,
  Box,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Grid,
} from "@mui/material";
import { styled } from "@mui/material/styles";

// ---------------------------------------------------------------------
const Images = [
  { id: 1, imgUrl: "/assets/RHOOD5.png" },
  { id: 2, imgUrl: "/assets/RHOOD5.png" },
  { id: 3, imgUrl: "/assets/RHOOD5.png" },
  { id: 4, imgUrl: "/assets/RHOOD5.png" },
  { id: 5, imgUrl: "/assets/RHOOD5.png" },
  { id: 6, imgUrl: "/assets/RHOOD5.png" },
  { id: 7, imgUrl: "/assets/RHOOD5.png" },
  { id: 8, imgUrl: "/assets/RHOOD5.png" },
  { id: 9, imgUrl: "/assets/RHOOD5.png" },
];

export default function AboutDetail() {
  return (
    <Stack direction="row">
      <TableContainer sx={{ width: "50%" }}>
        <Table aria-label="simple table">
          <TableBody>
            <TableRow
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell
                align="left"
                sx={{
                  color: "#fff",
                  fontFamily: "Inconsolata",
                  fontSize: "24px",
                }}
              >
                CONTRACT
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  color: "#fff",
                  fontFamily: "Inconsolata",
                  fontSize: "24px",
                }}
              >
                2345436346
              </TableCell>
            </TableRow>

            <TableRow
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell
                align="left"
                sx={{
                  color: "#fff",
                  fontFamily: "Inconsolata",
                  fontSize: "24px",
                }}
              >
                MAX SUPPLY
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  color: "#fff",
                  fontFamily: "Inconsolata",
                  fontSize: "24px",
                }}
              >
                10.000
              </TableCell>
            </TableRow>

            <TableRow
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell
                align="left"
                sx={{
                  color: "#fff",
                  fontFamily: "Inconsolata",
                  fontSize: "24px",
                }}
              >
                TOTAL SUPPLY
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  color: "#fff",
                  fontFamily: "Inconsolata",
                  fontSize: "24px",
                }}
              >
                9.800
              </TableCell>
            </TableRow>

            <TableRow
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell
                align="left"
                sx={{
                  color: "#fff",
                  fontFamily: "Inconsolata",
                  fontSize: "24px",
                }}
              >
                RESERVED SUPPLY
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  color: "#fff",
                  fontFamily: "Inconsolata",
                  fontSize: "24px",
                }}
              >
                200
              </TableCell>
            </TableRow>

            <TableRow
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell
                align="left"
                sx={{
                  color: "#fff",
                  fontFamily: "Inconsolata",
                  fontSize: "24px",
                }}
              >
                OWNERS
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  color: "#fff",
                  fontFamily: "Inconsolata",
                  fontSize: "24px",
                }}
              >
                4242
              </TableCell>
            </TableRow>

            <TableRow
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell
                align="left"
                sx={{
                  color: "#fff",
                  fontFamily: "Inconsolata",
                  fontSize: "24px",
                }}
              >
                FLOOR PRICE
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  color: "#fff",
                  fontFamily: "Inconsolata",
                  fontSize: "24px",
                }}
              >
                0.11
              </TableCell>
            </TableRow>

            <TableRow
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell
                align="left"
                sx={{
                  color: "#fff",
                  fontFamily: "Inconsolata",
                  fontSize: "24px",
                }}
              >
                VOLUME TRADED
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  color: "#fff",
                  fontFamily: "Inconsolata",
                  fontSize: "24px",
                }}
              >
                5084.99
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Stack
          sx={{
            borderTop: "1px solid #fff",
            color: "#fff",
            fontFamily: "Inconsolata",
            fontSize: "24px",
            p: "5%",
            textAlign: "start",
          }}
        >
          Each R/HOOD NFT is a ERC-721(A) non-fungible token designed for you,
          that entitles the holder to R/HOOD media platform for members +
          additional exclusive perks.
        </Stack>
      </TableContainer>
      <Grid container sx={{ width: "50%" }}>
        {Images.map((item) => (
          <Grid item xs={2} sm={4} md={4} key={item.id}>
            <Box
              component="img"
              src={item.imgUrl}
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
